"use client";
import React, { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { useSearch } from "@/context/SearchContext";

const Search = () => {
  const { setQuery } = useSearch();
  const [tempQuery, setTempQuery] = useState("");

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setQuery(tempQuery);
    }, 1200);

    return () => clearTimeout(delayDebounce);
  }, [tempQuery, setQuery]);

  return (
    <div className="max-w-md mx-auto sticky top-10 z-50 bg-white">
      <Input
        placeholder="Type fast. Impress your crush. 😁"
        className="shadow-md rounded-none border-black neue_machina_regular placeholder:text-xs sm:placeholder:text-base"
        value={tempQuery}
        type="search"
        onChange={(e) => setTempQuery(e.target.value)}
      />
    </div>
  );
};

export default Search;
